export default __webpack_public_path__ + "static/media/coverCovid.fa958694.png";